import axios from "axios";

export function getAccessRights() {
  return axios.get("/partner/admin/api/v1/access-rights");
}

export function getRoles(params) {
  return axios.get("/partner/admin/api/v1/roles", { params });
}

export function getRole(uuid) {
  return axios.get(`/partner/admin/api/v1/roles/${uuid}`);
}

export function createRole(data) {
  return axios.post("/partner/admin/api/v1/roles", data);
}

export function updateRole(uuid, data) {
  return axios.put(`/partner/admin/api/v1/roles/${uuid}`, data);
}

export function deleteRole(uuid) {
  return axios.delete(`/partner/admin/api/v1/roles/${uuid}`);
}
